import RowSlider from './rowSlider'
import Slider from './slider'
import Cards from './cards'
import xs from 'xstream'

export function main(sources) {
  const cards = sources.DOM.scope(
    '[data-carditem]',
    DOM => Cards({ ...sources, DOM }).DOM,
  )

  const rowSliders = sources.DOM.scope(
    '[data-rowslider]',
    DOM => RowSlider({ ...sources, DOM }).DOM,
  )

  const wordsSlider = sources.DOM.scope(
    '[data-wordsslider]',
    DOM => Slider({ ...sources, DOM }).DOM,
  )

  const imagesSlider = sources.DOM.scope(
    '[data-imagesslider]',
    DOM => Slider({ ...sources, DOM }).DOM,
  )

  return {
    DOM: xs.merge(cards, rowSliders, wordsSlider, imagesSlider),
  }
}

export default main



// WEBPACK FOOTER //
// ./main.js